import { useLocation, useNavigate } from "react-router-dom";
import { Box, Button, Container, Stack, Typography } from "@mui/material";
import { app_logo_full } from "@/constants";
import { tokens } from "@/tokens";
const termsData = [
  {
    heading: "1. Acceptance of Terms",
    data:
      "By using our Services, you agree to these Terms and our Privacy Policy. We may update these Terms from time to time, and your continued use of our Services constitutes acceptance of any changes",
  },
  {
    heading: "2. Eligibility",
    data:
      "To use our Services, you must be at least 18 years old and legally capable of entering into contracts.You must also provide accurate, complete, and current information.",
  },
  {
    heading: "3. Account Registration",
    data:
      "To access certain features of our Services, you may need to create an account. You are responsible for maintaining the confidentiality of your account information and for all activities that occur under your account. Notify us immediately of any unauthorized use of your account by reaching out to Security@tryriffs.com.",
  },
  {
    heading: "4. Use of Services",
    data:
      "You agree to use our Services only for lawful purposes and in accordance with any applicable laws and regulations. You may not use our Services to engage in fraudulent, abusive, or illegal activities.",
  },
  {
    heading: "5. Intellectual Property",
    data:
      "All content and materials provided through our Riffs Services, including but not limited to text,graphics, logos, and software, are the property of Riffs or its licensors and are protected by intellectual property laws. You may not use, reproduce, or distribute any content without our prior written consent.",
  },
  {
    heading: "6. Limitation of Liability",
    data:
      "To the maximum extent permitted by law, Riffs and its affiliates, officers, directors, employees,and agents shall not be liable for any indirect, incidental, special, consequential, or punitive damages arising out of or related to your use of our Services.",
  },
  {
    heading: "7. Indemnification",
    data:
      "You agree to indemnify and hold harmless Riffs and its affiliates, officers, directors, employees, and agents from any claims, liabilities, damages, losses, and expenses, including reasonable attorneys' fees, arising out of or related to your use of our Services or any violation of these Terms.",
  },
  {
    heading: "8. Termination",
    data:
      "Riffs reserves the right to suspend or terminate your access to our Services at any time, with or without cause, and with or without notice. Upon termination, you must cease all use of our Services and return or destroy any materials obtained from us.",
  },
  {
    heading: "9. Governing Law",
    data:
      "These Terms shall be governed by and construed in accordance with the laws of the State of New York within the Unites States of America, without regard to its conflict of law principles. Any disputes arising from these Terms or your use of our Services shall be resolved in the courts of the State of New York",
  },
  {
    heading: "10. Miscellaneous",
    data:
      "If any provision of these Terms is found to be invalid or unenforceable, the remaining provisions will continue in full force and effect. Our failure to enforce any right or provision of these Terms will not constitute a waiver of such right or provision.",
  },
];

const Terms = () => {
  const navigate = useNavigate();
  const location = useLocation();
  return (
    <Box>
      <Stack
        spacing={3}
        height={"70vh"}
        textAlign="center"
        alignItems="center"
        justifyContent="center"
        bgcolor={tokens.brand.primary}
        padding='0px 10px'
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <img src={app_logo_full} alt="" width={98} />
        </Box>
        <Typography variant='h2' color={tokens.bg.surface} sx={{ fontSize: { xs: "25px", sm: "32px", md: "36px" } }}>Terms of Service</Typography>
        <Typography variant="h6" color={tokens.bg.surface}>Last updated: April 04, 2024</Typography>
        <Box sx={{ display: "flex", pt: 6, alignItems: "center", gap: 2 }}>
          <Button
            variant={location.pathname === "/privacy" ? "contained" : "outlined"}
            size="large"
            sx={{
              width: "160px",
              borderRadius: tokens.radius.md,
              backgroundColor:
                location.pathname === "/privacy" ? "#E0F7F9" : "transparent",
              color: location.pathname === "/privacy" ? tokens.brand.primary : "#CFD8DC",
              borderColor: location.pathname === "/privacy" ? "none" : "#CFD8DC",
              "&:hover": {
                backgroundColor:
                  location.pathname === "/privacy" ? "#B2EBF2" : "rgba(38, 198, 218, 0.1)",
                color: location.pathname === "/privacy" ? tokens.brand.primary : "#26C6DA",
                borderColor: location.pathname === "/privacy" ? "none" : "#26C6DA",
              },
            }}
            onClick={() => navigate("/privacy")}
          >
            Privacy
          </Button>
          <Button
            variant={location.pathname === "/terms" ? "contained" : "outlined"}
            size="large"
            sx={{
              width: "160px",
              borderRadius: tokens.radius.md,
              backgroundColor:
                location.pathname === "/terms" ? "#E0F7F9" : "transparent",
              color: location.pathname === "/terms" ? tokens.brand.primary : "#CFD8DC",
              borderColor: location.pathname === "/terms" ? "none" : "#CFD8DC",
              "&:hover": {
                backgroundColor:
                  location.pathname === "/terms" ? "#B2EBF2" : "rgba(38, 198, 218, 0.1)",
                color: location.pathname === "/terms" ? tokens.brand.primary : "#26C6DA",
                borderColor: location.pathname === "/terms" ? "none" : "#26C6DA",
              },
            }}
            onClick={() => navigate("/terms")}
          >
            Terms
          </Button>
        </Box>
      </Stack>
      <Container maxWidth="md" sx={{ pt: 6 }}>
        <Typography variant="h6" lineHeight={2}>
          Welcome to Riffs. These Terms of Service ("Terms") govern your use of
          our website, applications, and services (collectively, the
          "Services"). By accessing or using our Services, you agree to be bound
          by these Terms. If you do not agree, please do not use our Services.
        </Typography>
      </Container>
      <Container maxWidth="md" sx={{ pt: 4, pb: 6 }}>
        {termsData.map((section, index) => (
          <Box key={index} sx={{ mb: 4 }}>
            <Typography variant="h6" mb={2}>
              {section.heading}
            </Typography>
            <Typography variant="body1" lineHeight={1.8}>
              {section.data}
            </Typography>
          </Box>
        ))}
      </Container>
    </Box>
  );
};

export default Terms;

